import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import {useTheme} from '@material-ui/core/styles';

const LocationIcon = ({primary, ...props}) => {
  const theme = useTheme();
  const fill = primary
    ? theme.palette.primary.main
    : theme.palette.common.white;

  return (
    <SvgIcon
      {...props}
      width="24.06"
      height="33.635"
      viewBox="0 0 24.06 33.635"
    >
      <g transform="translate(-72.48)">
        <path
          fill={fill}
          d="M84.51,0A12.037,12.037,0,0,0,73.781,17.442l6.173,13.286a5.024,5.024,0,0,0,9.112,0l6.173-13.286A12.037,12.037,0,0,0,84.51,0Zm8.837,16.5c-.012.024.279-.6-6.2,13.336a2.907,2.907,0,0,1-5.278,0c-6.452-13.886-6.184-13.311-6.2-13.336a9.907,9.907,0,1,1,17.673,0Z"
        />
        <path
          fill={fill}
          d="M171.578,93.068a5.872,5.872,0,1,0,5.872,5.872,5.879,5.879,0,0,0-5.872-5.872Zm0,9.631a3.759,3.759,0,1,1,3.759-3.759A3.763,3.763,0,0,1,171.578,102.7Z"
          transform="translate(-87.068 -86.921)"
        />
      </g>
    </SvgIcon>
  );
};

export default LocationIcon;
